<template>
  <div>
    <channels-search-input ref="searchInput" @search-channels="emitSearchEvent" variant="white" />
    <button @click="emitFilterToggle" class="top-filter-section-btn">
      {{ $t('filters.title') }}
      <span class="top-filter-icon icon-filter-inactive" aria-hidden="true"></span>
    </button>
  </div>
</template>

<script>
import ChannelsSearchInput from './channels-search-input'
export default {
  name: 'channels-search-filter-toggle',
  components: { ChannelsSearchInput },
  methods: {
    emitSearchEvent (e) {
      this.$emit('search-channels', e)
    },
    emitFilterToggle () {
      this.$emit('filter-toggle')
    },
    clearSearch () {
      this.$refs.searchInput.clearSearch()
    }
  }
}
</script>

<style scoped lang="scss">
.top-filter-section-btn {
  position: relative;
  border-radius: .5rem;
  padding: 1.5rem 2rem 1.5rem 1.6rem;
  width: 100%;
  background: $white;
  color: $dark-grey;
  font-size: 1.4rem;
  font-weight: 400;
  text-align: left;

  .top-filter-icon {
    position: absolute;
    top: 50%;
    right: 1.4rem;
    transform: translateY(-50%);
    font-size: 2.2rem;
  }
}
</style>
